
import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";



export default function AjeerConfirm({ PopUp, setPopUp, apiCall }) {
    const [loading, setLoading] = useState(false);
    return (
        <>
            <div
                className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${PopUp ? "flex" : "hidden"
                    }`}
            >
                <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
                    <div className="flex justify-between items-center w-full">
                        <h1
                            className="text-md font-semibold cursor-pointer"
                            onClick={() => {
                                setPopUp(false);
                            }}
                        >
                            <IoMdClose />
                        </h1>
                    </div>
                    <div className="w-full place-items-center">
                        <div className="form-control w-full place-items-center">
                            <h2 className="label place-items-center">
                                {"Are you Sure Submit Fee ?"}
                            </h2>


                        </div>
                        <div className="w-full flex flex-col gap-3 my-3 p-2">
                            <div
                                className="flex gap-3 w-full justify-center"
                                style={{ margin: 2 }}
                            >
                                <button
                                    onClick={() => apiCall()}
                                    className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm" // Decreased padding and font size
                                >
                                    {" "}
                                    <p>Submit</p>
                                    {loading ? <CgSpinner className="animate-spin" /> : ""}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

